module.exports = {
  localeName: 'es-ES',
  momentFormat: 'DD/MM/YYYY'
};
